// extracted by mini-css-extract-plugin
export var accountContent = "account-data-module--account-content--5oh61";
export var accountWrapper = "account-data-module--account-wrapper--wZaPm";
export var sectionHeader = "account-data-module--section-header--eupMP";
export var sectionHeaderDescription = "account-data-module--section-header-description--iEuxk";
export var sectionHeaderTitle = "account-data-module--section-header-title--OyeZL";
export var title = "account-data-module--title--BMGGj";